import { cn } from '@/lib/utils'
import { Folder } from 'lucide-react'
import { KNOWLEDGE_SOURCE_PROVIDERS } from '@/lib/knowledge-sources/providers'
import type { KnowledgeSourceProvider } from '@/lib/knowledge-sources/types'

export function KnowledgeSourceProviderIcon({ provider, className }: { provider: KnowledgeSourceProvider; className?: string }) {
  switch (provider) {
    case 'google_drive':
      return <svg viewBox="0 0 24 24" className={cn('h-4 w-4 shrink-0', className)} aria-hidden="true" focusable="false" data-provider={provider}>
        <path fill="#0F9D58" d="M8 2 0 16l4 7 8-14Z" />
        <path fill="#F4B400" d="M8 2h8l8 14h-8Z" />
        <path fill="#4285F4" d="M8 16h16l-4 7H4Z" />
      </svg>
    default: {
      const exhaustive: never = provider
      return exhaustive
    }
  }
}

export function KnowledgeSourceFolderIcon({ sourceType, className }: { sourceType?: string | null; className?: string }) {
  const provider = KNOWLEDGE_SOURCE_PROVIDERS.find(provider => provider.id === sourceType)
  if (provider) return <KnowledgeSourceProviderIcon provider={provider.id} className={className} />
  return <Folder aria-hidden="true" className={className} />
}
